import {
  React, Fragment, PureComponent,
} from 'react';
import _ from 'lodash';
import { Dialog, Transition } from '@headlessui/react';
import { XIcon } from '@heroicons/react/outline';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import withAPI from '../../hocs/with-api';
import ValidationError from '../notifications/validation-errors';

class ModalSetHubEmails extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      emails: '',
      isLoading: true,
      errors: {},
    };
  }

  componentDidMount() {
    this.setInitialState();
  }

  setInitialState = async () => {
    const {
      httpRequest, selectedCompany, setEmailsHubId, managerType,
    } = this.props;

    var url = `companies/${selectedCompany.id}/hubs/${setEmailsHubId}/managers-trip-missing-external`;
    if (managerType === 'mmr_managers') {
      url = `companies/${selectedCompany.id}/hubs/${setEmailsHubId}/managers-external`;
    } else if (managerType === 'ivmr_managers') {
      url = `companies/${selectedCompany.id}/hubs/${setEmailsHubId}/managers-ivmr-external`;
    }

    const response = await httpRequest({
      method: 'get',
      url: url,
    }).catch(() => this.setState({ isLoading: false }));
    if (response) {
      const {
        data: {
          data,
        },
      } = response;

      this.setState({ emails: data || '' }, () => this.setState({ isLoading: false }));
    }
  }

  onSave = async () => {
    const {
      httpRequest, selectedCompany, setEmailsHubId, setOpen, managerType,
    } = this.props;
    const { emails } = this.state;

    this.setState({ isLoading: true });

    var url = `companies/${selectedCompany.id}/hubs/${setEmailsHubId}/managers-trip-missing-external`;
    if (managerType === 'mmr_managers') {
      url = `companies/${selectedCompany.id}/hubs/${setEmailsHubId}/managers-external`;
    } else if (managerType === 'ivmr_managers') {
      url = `companies/${selectedCompany.id}/hubs/${setEmailsHubId}/managers-ivmr-external`;
    }

    const response = await httpRequest({
      method: 'patch',
      url: url,
      data: { emails },
    }).catch((error) => {
      this.setState({
        errors: error?.response?.data,
        isLoading: false,
      });
    });
    if (response) {
      setOpen(false);
    }
  }

  render() {
    const {
      open, setOpen, title, subtitle,
    } = this.props;
    const {
      emails, errors, isLoading,
    } = this.state;

    return (
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed z-10 inset-0 overflow-y-auto"
          onClose={setOpen}
        >
          <div className="flex items-center justify-center min-h-screen p-4 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left
              overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg
              sm:w-full sm:p-6"
              >
                <button type="button" className="float-right" onClick={() => setOpen(false)}>
                  <XIcon className="flex-shrink-0 mr-1.5 h-5 w-5 text-black-400" aria-hidden="true" />
                </button>
                <div>
                  <div className="mt-3 text-center sm:mt-5">
                    <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                      {title}
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        {subtitle}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                  {
                    !_.isEmpty(errors) && (
                      <ValidationError errors={errors} addClass="sm:col-span-6" />
                    )
                  }
                  <div className="sm:col-span-6">
                    <label htmlFor="emails" className="block text-sm font-medium text-gray-700">
                      Email list (use semicolon between emails)
                    </label>
                    <div className="mt-1">
                      <textarea
                        value={emails || ''}
                        id="emails"
                        name="emails"
                        rows="4"
                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block
                                w-full sm:text-sm border border-gray-300 rounded-md p-2"
                        onChange={(e) => this.setState({ emails: e.target.value })}
                        placeholder="Enter email list"
                      />
                    </div>
                    <div className="mt-5 flex justify-center items-center">
                      <button
                        onClick={this.onSave}
                        type="button"
                        disabled={isLoading}
                        className="inline-flex justify-center py-2 px-4 mt-3 sm:mt-0 border border-transparent
                            shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700
                            focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      >
                        {isLoading && (<div className="animate-spin border-b-2 rounded-full h-5 w-5 mr-3" />)}
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    );
  }
}

ModalSetHubEmails.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  selectedCompany: PropTypes.object.isRequired,
  setEmailsHubId: PropTypes.number.isRequired,
  httpRequest: PropTypes.func.isRequired,
  managerType: PropTypes.string.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

ModalSetHubEmails.defaultProps = {
  open: false,
  setOpen: () => {},
  title: '',
  subtitle: '',
};

export default compose(
  withAPI,
)(ModalSetHubEmails);
